export default "__VITE_ASSET__CIQvqxmG__"